module.exports = __webpack_public_path__ + "img/b1 (4).b366039d.png";